import addScript from "../../../utils/browser/addScript";
const setup = _ref => {
  var _JSON$parse;
  let {
    isSDKTrackings
  } = _ref;
  const GTMId = (_JSON$parse = JSON.parse(localStorage.getItem("@mobi/analytics"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.GTMId;
  if (isSDKTrackings) {
    window._containerGTM = GTMId;
    return addScript("https://libs-digitalanalytics.cloud.itau.com.br/assets/framework-analytics-web.min.js", [{
      key: "id",
      value: "SDKWebAnalytics"
    }, {
      key: "type",
      value: "text/javascript"
    }]).then(_ => {
      var _document;
      const webComponentName = "framework-analytics-web";
      const DOMWebComponentGetElements = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementsByTagName(webComponentName);
      const DOMWebComponentQuantity = DOMWebComponentGetElements === null || DOMWebComponentGetElements === void 0 ? void 0 : DOMWebComponentGetElements.length;
      const doesntExistWebComponentElement = DOMWebComponentQuantity === 0;
      if (doesntExistWebComponentElement) {
        var _document$body;
        const DOMWebComponentElement = document.createElement(webComponentName);
        (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.appendChild(DOMWebComponentElement);
      }
    });
  } else {
    return addScript("https://www.itau.com.br/_arquivosestaticos/Itau/defaultTheme/js/da/framework/importLibJSFrameworkDA.js?" + GTMId, [{
      key: "id",
      value: "importLibJSFrameworkDA"
    }, {
      key: "type",
      value: "text/javascript"
    }]).then(_ => addScript("https://www.itau.com.br/_arquivosestaticos/Itau/defaultTheme/js/da/framework/frameworkDA.js?" + GTMId, [{
      key: "id",
      value: "frameworkDA"
    }, {
      key: "type",
      value: "text/javascript"
    }])).then(_ => {
      console.log("%c @analytics/ga - ready", "color: red");
    });
  }
};
export default setup;